import { render, staticRenderFns } from "./UsageDetailTable.vue?vue&type=template&id=0b3c3661&scoped=true&"
import script from "./UsageDetailTable.vue?vue&type=script&lang=js&"
export * from "./UsageDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c3661",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3c3661')) {
      api.createRecord('0b3c3661', component.options)
    } else {
      api.reload('0b3c3661', component.options)
    }
    module.hot.accept("./UsageDetailTable.vue?vue&type=template&id=0b3c3661&scoped=true&", function () {
      api.rerender('0b3c3661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/usagedetailtable/UsageDetailTable.vue"
export default component.exports